/* author:莫兰;
*  date:2020/12/19;
*  explan:门店采购相关api；
*/
import api from "./api.js";
let baseURL4 = process.env.VUE_APP_Url4;
export function getProcureRequest(params){return api.post(`${baseURL4}api/ProcureRequest/list`,params)}//采购申请单
export function setProcureRequest(params){return api.post(`${baseURL4}api/ProcureRequest/create`,params)}//创建申请单
export function delProcureRequest(params){return api.get(`${baseURL4}api/ProcureRequest/Delete`,params)}//删除待提交的申请单
export function procureRequestDl(params){return api.get(`${baseURL4}api/ProcureRequest/get`,params)}//获取申请单
export function confirmProcureRequest(params){return api.get(`${baseURL4}api/ProcureRequest/shopconfirm`,params)}//门店确认采购/api/ProcureRequest/
export function getShopAcceptanceList(params){return api.post(`${baseURL4}api/Procure/GetShopAcceptanceList`,params)}//验收列表
export function getDistributionInfo(params){return api.get(`${baseURL4}api/Procure/GetDistributionInfo`,params)}//分拨详情
export function shopAcceptance(params){return api.post(`${baseURL4}api/Procure/ShopAcceptance`,params)}//门店验货
export function getNoCheckCount(params){return api.get(`${baseURL4}api/Procure/GetNoCheckCount`,params)}//门店验货
export function setNewGoods(params){return api.post(`${baseURL4}api/NewGoodsRequest/create`,params)}//添加新品
export function shopAKeyAcceptance(params){return api.get(`${baseURL4}api/Procure/AKeyAcceptance`,params)}//一键验货



// export function getNoCheckCount(params){return api.get(`${baseURL4}api/Procure/UpLoadDistribution`,params)}//下载分拨单/api/Procure/UpLoadDistribution
